import { getSafeValue } from './security';
import { getVehicleProfile } from './FleetHelpers';
import config from '../config';

const deepLinkMode = {
  bicycle: 'b',
  car: 'd',
  pedestrian: 'w',
  truck: 'tr',
};

const deepLinkAvoid = {
  tollRoad: 'tollroad',
  motorway: 'motorway',
  ferry: 'boatFerry',
  tunnel: 'tunnel',
  dirtRoad: 'dirtRoad',
};

export const getMode = (fleetType) => {
  const mode = getSafeValue(deepLinkMode, fleetType);
  return mode ? `?m=${mode}` : '?m=d';
};

export const getAvoid = (avoidFeatures) => {
  const avoids = avoidFeatures
    .map((feature) => getSafeValue(deepLinkAvoid, feature))
    .filter((avoid) => avoid !== undefined);
  return avoids.length > 0 ? `&a=${avoids.join(',')}` : '';
};

export const getCoordinates = (stops) => {
  return stops.map((stop) => `${stop.location.lat},${stop.location.lng}`).join('/');
};

export const createNavLink = (tour, tourPlanner) => {
  const baseUrl = config.share.url;
  const vehicleProfile = getVehicleProfile(
    tour.typeId,
    tourPlanner.vehicles,
    tourPlanner.vehicleProfiles,
  );
  const coordinates = getCoordinates(tour.stops);
  const mode = getMode(vehicleProfile?.fleetType);
  const avoid =
    vehicleProfile && vehicleProfile.avoid?.features ? getAvoid(vehicleProfile.avoid.features) : '';

  return `${baseUrl}/${coordinates}${mode}${avoid}`;
};
